/**
 * Shared step-machine constants + helpers for the onboarding flow.
 *
 * The 4 steps map 1:1 to the 4 `StepDots` (current = index + 1). The
 * project-capture "Basics" step was removed 2026-07-06 (the captured-renovation
 * "project" feature is hidden product-wide); onboarding is now purely the
 * email-OTP signup path that lands on the assistant.
 *
 * `phoneErrorKey` lives here (rather than in the flow) so the Phone step and
 * the flow share it without a circular import.
 */
import { ApiError } from "@/lib/api-client";

/** Map a phone-signup-start error to a localized key (HTTP 429 → throttle). */
export function phoneErrorKey(error: unknown): string {
  if (error instanceof ApiError && error.status === 429) {
    return "phone.errRate";
  }
  return "phone.errGeneric";
}

export const ONBOARDING_STEPS = [
  "welcome",
  "email",
  "emailOtp",
  "done",
] as const;

export type OnboardingStep = (typeof ONBOARDING_STEPS)[number];

/**
 * Heading style shared by the inner step screens. The display voice
 * (`font-display`, Onest at display weight) is correct here — these ARE
 * screen titles, which is the one job that voice has.
 */
export const STEP_H1_CLASS =
  "font-display m-0 text-[26px] font-extrabold leading-[1.1] text-foreground";

/** Section sub-label above pill/segmented groups (matches the design label). */
export const STEP_LABEL_CLASS =
  "mb-[9px] block text-[13px] font-semibold text-foreground";
